// import React, { Component } from "react";
// import { connect } from "react-redux";
// import { getLogout } from "../../containers/Login/Store";
// import { Link, withRouter } from "react-router-dom";
// import adminAvtr from "../../images/admin.png";
// import axios from "axios";
// import { API_URL } from "../../utils/constants";
// import { toast } from "react-toastify";

// class Header extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       domains: [],
//       selectedDomain: "",
//     };
//   }

//   async componentDidMount() {
//     this.fetchDomains();
//   }

//   fetchDomains = async () => {
//     try {
//       const {
//         LoginStore: { user },
//       } = this.props;
//       const response = await axios.get(`${API_URL}user/domains`, {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: user.api_token ? `Bearer ${user.api_token}` : "",
//         },
//       });
//       if (response.data) {
//         this.setState({ domains: response.data.domains });
//       } else {
//         toast.error("Failed to fetch domains");
//       }
//     } catch (error) {
//       toast.error("Error fetching domains");
//     }
//   };

//   handleDomainChange = async (event) => {
//     const newDomainName = event.target.value;
//     this.setState({ selectedDomain: newDomainName });

//     try {
//       const token = localStorage.getItem("api_token");
//       const response = await axios.post(
//         `${API_URL}switch-domain`,
//         { new_domain_name: newDomainName },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (response.api_token) {
//         localStorage.setItem("api_token", response.api_token);
//         window.location.reload();
//       } else {
//         localStorage.removeItem("api_token");
//       }

//     } catch (error) {
//       console.error("Error switching domain:", error);
//       toast.error("Error switching domain");
//     }
//   };

//   logout = async () => {
//     const {
//       getLogout,
//       history,
//       LoginStore: { user },
//     } = this.props;
//     axios.defaults.headers.common["Authorization"] = `Bearer ${user.api_token}`;
//     await axios({
//       method: "POST",
//       url: `${API_URL}logout`,
//       data: { type: 2 },
//       headers: { "Content-Type": "application/json" },
//     });
//     axios.defaults.headers.common["Authorization"] = null;
//     localStorage.clear();
//     await getLogout();
//     history.push("/");
//   };

//   render() {
//     const { domains, selectedDomain } = this.state;
//     return (
//       <div className="site-header container-fluid">
//         <div className="spacer" />
//         <div className="domain-switcher">
//           <select value={selectedDomain} onChange={this.handleDomainChange}>
//             <option value="">Select Domain</option>
//             {domains.map((domain) => (
//               <option key={domain.id} value={domain.domain_name}>
//                 {domain.domain_name}
//               </option>
//             ))}
//           </select>
//         </div>
//         <div className="user-profile">
//           <div className="dropdown">
//             <div
//               className="user-avatar dropdown-toggle"
//               type="button"
//               data-toggle="dropdown"
//               aria-haspopup="true"
//               aria-expanded="false"
//             >
//               <img className="" src={adminAvtr} alt="User Avatar" />
//             </div>
//             <div className="dropdown-menu dropdown-menu-right">
//               <Link className="nav-link" to="/user-settings">
//                 <i className="fa fa-user"></i>Manage Profile
//               </Link>
//               <Link className="nav-link" to="#" onClick={() => this.logout()}>
//                 <i className="fa fa-power-off"></i>Logout
//               </Link>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// const mapStateToProps = (state) => state;
// const mapDispatchToProps = { getLogout };
// export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));


import React, { Component } from "react";
import { connect } from "react-redux";
import { getLogout } from "../../containers/Login/Store";
import { Link, withRouter } from "react-router-dom";
import adminAvtr from "../../images/admin.png";
import axios from "axios";
import { API_URL } from "../../utils/constants";
import { toast } from "react-toastify";
import CloudProviderSwitcher from "../CloudProviderSwitcher";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      domains: [],
      selectedDomain: "",
    };
  }

  async componentDidMount() {
    this.fetchDomains();
  }

  fetchDomains = async () => {
    try {
      const {
        LoginStore: { user },
      } = this.props;
      const response = await axios.get(`${API_URL}user/domains`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.api_token ? `Bearer ${user.api_token}` : "",
        },
      });

      if (response.data && response.data.domains) {
        const domains = response.data.domains;
        const activeDomain = domains.find((domain) => domain.is_active);

        this.setState({
          domains,
          selectedDomain: activeDomain ? activeDomain.domain_name : "",
        });
      } else {
        toast.error("Failed to fetch domains");
      }
    } catch (error) {
      toast.error("Error fetching domains");
    }
  };

  handleDomainChange = async (event) => {
    const newDomainName = event.target.value;
    this.setState({ selectedDomain: newDomainName });

    try {
      const token = localStorage.getItem("api_token");
      const response = await axios.post(
        `${API_URL}switch-domain`,
        { new_domain_name: newDomainName },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.api_token) {
        localStorage.setItem("api_token", response.api_token);
        window.location.reload();
      } else {
        localStorage.removeItem("api_token");
      }
    } catch (error) {
      console.error("Error switching domain:", error);
      toast.error("Error switching domain");
    }
  };

  logout = async () => {
    const {
      getLogout,
      history,
      LoginStore: { user },
    } = this.props;
    localStorage.clear();
    await getLogout();
    history.push("/");
    window.location.reload()
  };

  render() {
    const { domains, selectedDomain } = this.state;

    return (
      <div className="site-header container-fluid">
        <div className="spacer" />
        <CloudProviderSwitcher />
        <div className="domain-switcher">
          <select
            value={selectedDomain}
            onChange={this.handleDomainChange}
            className="form-control custom-dropdown"
          >
            <option value="" disabled>
              Select Domain
            </option>
            {domains.map((domain) => (
              <option
                key={domain.id}
                value={domain.domain_name}
                disabled={domain.is_active}
              >
                {domain.domain_name} {domain.is_active ? "(Active)" : ""}
              </option>
            ))}
          </select>
        </div>
        <div className="user-profile">
          <div className="dropdown">
            <div
              className="user-avatar dropdown-toggle"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img className="" src={adminAvtr} alt="User Avatar" />
            </div>
            <div className="dropdown-menu dropdown-menu-right">
              <Link className="nav-link" to="/user-settings">
                <i className="fa fa-user"></i> Manage Profile
              </Link>
              <Link className="nav-link" to="#" onClick={() => this.logout()}>
                <i className="fa fa-power-off"></i> Logout
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => state;
const mapDispatchToProps = { getLogout };
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
